<template>
  <b-card
    no-body
    class="comments-container mb-0"
    :style="{ width: show ? '700px' : '250px' }"
  >
    <b-card-header
      v-if="show"
      header-tag="header"
      header-bg-variant="primary"
      header-text-variant="white"
      class="p-1 cursor-pointer header mx-auto"
      role="tab"
      :class="show ? null : 'collapsed'"
      :aria-expanded="show ? 'true' : 'false'"
      aria-controls="collapse-4"
      @click="() => {
        show = !show
        unread = 0
      }"
    >
      <strong>{{ $t("lbl_contact") }}<b-badge v-if="unread" class="ml-1" variant="danger" pill>{{ $t("lbl_new") }}</b-badge></strong>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 9.17C16.8126 8.98375 16.5592 8.87921 16.295 8.87921C16.0308 8.87921 15.7774 8.98375 15.59 9.17L12 12.71L8.46001 9.17C8.27265 8.98375 8.0192 8.87921 7.75501 8.87921C7.49082 8.87921 7.23737 8.98375 7.05001 9.17C6.95628 9.26297 6.88189 9.37357 6.83112 9.49543C6.78035 9.61729 6.75421 9.74799 6.75421 9.88C6.75421 10.012 6.78035 10.1427 6.83112 10.2646C6.88189 10.3864 6.95628 10.497 7.05001 10.59L11.29 14.83C11.383 14.9237 11.4936 14.9981 11.6154 15.0489C11.7373 15.0997 11.868 15.1258 12 15.1258C12.132 15.1258 12.2627 15.0997 12.3846 15.0489C12.5064 14.9981 12.617 14.9237 12.71 14.83L17 10.59C17.0937 10.497 17.1681 10.3864 17.2189 10.2646C17.2697 10.1427 17.2958 10.012 17.2958 9.88C17.2958 9.74799 17.2697 9.61729 17.2189 9.49543C17.1681 9.37357 17.0937 9.26297 17 9.17Z"
          fill="white"
        />
      </svg>
    </b-card-header>
    <b-collapse id="accordion-1" v-model="show" role="tabpanel">
      <b-card-body
        class="comments scrollbar"
        v-infinite-scroll="getMoreComments"
        :infinite-scroll-disabled="disableLoadMore"
      >
        <b-card-text v-if="!comments.length">
          <span v-html="$t('lbl_no_new_messages_from_processor_supplier_of_this_order_', 
            {0: $t(isProcessor?'lbl_supplier':'lbl_laboratory')})"></span>
        </b-card-text>
        <b-container
          v-for="(cmt, index) in comments"
          :key="cmt.id"
          class="d-flex flex-column"
          :class="cmt.newComment && 'new-comment'"
          style="margin-bottom: 0.5rem"
        >
          <b-row>
            <b-col
              class="px-0"
              style="minWidth: calc(40px + 1rem); maxWidth: calc(40px + 1rem); paddingLeft: 7px !important;"
            >
              <b-img
                v-if="cmt.avatar"
                :src="appUtils.getImageURL(cmt.avatar)"
                @error="$set(comments, index, { ...cmt, avatar: false })"
                fluid
                alt=""
                rounded="circle"
                style="width: 40px; height: 40px;"
              ></b-img>
              <span
                v-else
                class="b-avatar badge-minimal badge-light-primary rounded-circle"
                style="width: 40px; height: 40px"
              >
                <svg
                  viewBox="0 0 16 16"
                  width="1em"
                  height="1em"
                  focusable="false"
                  role="img"
                  aria-label="person fill"
                  aria-hidden="true"
                  alt="avatar"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi-person-fill b-icon bi"
                >
                  <g>
                    <path
                      fill-rule="evenodd"
                      d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    ></path>
                  </g>
                </svg>
                <span
                  class="b-avatar-badge badge-success"
                  style="font-size: calc(11.2px); bottom: 0px; right: 0px"
                >
                </span>
              </span>
            </b-col>
            <b-col
              class="px-1 d-flex flex-column"
              style="border-radius: 10px"
            >
              <p class="pt-1 mb-0">
                <b style="margin-right: 5px;">{{ cmt.name }}</b><span v-if="cmt.org_name" style="font-size: 12px;">({{ cmt.org_name }})</span>
              </p>
              <p v-if="!cmt.isShowTranslation" class="py-1 mb-0 text-black">
                {{ cmt.content }}
              </p>
              <p v-else class="py-1 mb-0 text-black" style="font-style: italic;">
                {{ cmt.translatedContent }}
              </p>
              
              <b-row v-if="cmt.medias.length > 0" class="mb-1 attachments d-flex items-center ml-0">
                <b-link
                  v-for="(file, fileIndex) in cmt.medias"
                  :key="file + fileIndex"
                  :href="file.url"
                  target="_blank"
                  class="d-flex items-center bg-grey position-relative rounded d-block"
                  style="background-color: #ecebeb"
                >
                  <b-img
                    v-if="file.type === 'image'"
                    :src="appUtils.getImageURL(file.url)"
                    style="max-width: 180px"
                  ></b-img>
                  <span
                    v-else
                    class="b-avatar badge-minimal badge-light-primary rounded-circle"
                    style="width: 40px; height: 40px"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-file-earmark-text-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1z"
                      />
                    </svg>
                  </span>
                  <span v-if="file.type === 'text'" class="font-weight-bold file-name">{{ file.name }}</span>
                </b-link>
              </b-row>
              <p
                class="pr-1 mb-0 d-flex justify-between"
                style="font-size: 11px; padding-bottom: 0.5rem"
              >
                <strong v-if="!cmt.isShowTranslation" @click="translate(cmt.content, index)" class="cursor-pointer hover-undeline">{{ $t('lbl_see_translation') }}</strong>
                <strong v-else @click="() => {cmt.isShowTranslation=false}" class="cursor-pointer hover-undeline"> {{ $t('lbl_see_original_content') }}</strong>
                <span>{{ moment(cmt.send_at).format("HH:mm DD/MM/YYYY") }}</span>
              </p>
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
      <b-card-footer>
        <b-row v-if="attachment_url_list.length > 0" class="mb-1 attachments d-flex items-center">
          <div
            v-for="(file, fileIndex) in list_attachments_file"
            :key="file + fileIndex"
            class=" d-flex bg-grey position-relative rounded"
          >
            <b-img
              v-if="file.type === 'image'"
              :src="appUtils.getImageURL(file.url)"
              style="max-width: 180px"
            ></b-img>
            <span
              v-else
              class="b-avatar badge-minimal badge-light-primary rounded-circle"
              style="width: 40px; height: 40px"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-file-earmark-text-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1z"
                />
              </svg>
            </span>
            <span v-if="file.type === 'text'" class="font-weight-bold file-name" style="line-height: 40px;">{{ file.name }}</span>
            <b-button-close @click="removeAttachment(fileIndex)" class="position-absolute" text-variant="outline-secondary"></b-button-close>
          </div>
        </b-row>
        <b-row
          class="d-flex items-center position-relative"
          style="flex-wrap: nowrap"
        >
          <svg
            @click="handleTriggerUploadFile"
            class="position-absolute upload-icon cursor-pointer"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 20H6C5.73478 20 5.48043 19.8946 5.29289 19.7071C5.10536 19.5196 5 19.2652 5 19V5C5 4.73478 5.10536 4.48043 5.29289 4.29289C5.48043 4.10536 5.73478 4 6 4H11V7C11 7.79565 11.3161 8.55871 11.8787 9.12132C12.4413 9.68393 13.2044 10 14 10H17V12C17 12.2652 17.1054 12.5196 17.2929 12.7071C17.4804 12.8946 17.7348 13 18 13C18.2652 13 18.5196 12.8946 18.7071 12.7071C18.8946 12.5196 19 12.2652 19 12V9C19 9 19 9 19 8.94C18.9896 8.84813 18.9695 8.75763 18.94 8.67V8.58C18.8919 8.47718 18.8278 8.38267 18.75 8.3L12.75 2.3C12.6673 2.22222 12.5728 2.15808 12.47 2.11C12.4402 2.10576 12.4099 2.10576 12.38 2.11C12.2784 2.05174 12.1662 2.01434 12.05 2H6C5.20435 2 4.44129 2.31607 3.87868 2.87868C3.31607 3.44129 3 4.20435 3 5V19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H13C13.2652 22 13.5196 21.8946 13.7071 21.7071C13.8946 21.5196 14 21.2652 14 21C14 20.7348 13.8946 20.4804 13.7071 20.2929C13.5196 20.1054 13.2652 20 13 20ZM13 5.41L15.59 8H14C13.7348 8 13.4804 7.89464 13.2929 7.70711C13.1054 7.51957 13 7.26522 13 7V5.41ZM8 8C7.73478 8 7.48043 8.10536 7.29289 8.29289C7.10536 8.48043 7 8.73478 7 9C7 9.26522 7.10536 9.51957 7.29289 9.70711C7.48043 9.89464 7.73478 10 8 10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9C10 8.73478 9.89464 8.48043 9.70711 8.29289C9.51957 8.10536 9.26522 8 9 8H8ZM14 12H8C7.73478 12 7.48043 12.1054 7.29289 12.2929C7.10536 12.4804 7 12.7348 7 13C7 13.2652 7.10536 13.5196 7.29289 13.7071C7.48043 13.8946 7.73478 14 8 14H14C14.2652 14 14.5196 13.8946 14.7071 13.7071C14.8946 13.5196 15 13.2652 15 13C15 12.7348 14.8946 12.4804 14.7071 12.2929C14.5196 12.1054 14.2652 12 14 12ZM20.71 17.29L18.71 15.29C18.6149 15.199 18.5028 15.1276 18.38 15.08C18.1365 14.98 17.8635 14.98 17.62 15.08C17.4972 15.1276 17.3851 15.199 17.29 15.29L15.29 17.29C15.1017 17.4783 14.9959 17.7337 14.9959 18C14.9959 18.2663 15.1017 18.5217 15.29 18.71C15.4783 18.8983 15.7337 19.0041 16 19.0041C16.2663 19.0041 16.5217 18.8983 16.71 18.71L17 18.41V21C17 21.2652 17.1054 21.5196 17.2929 21.7071C17.4804 21.8946 17.7348 22 18 22C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21V18.41L19.29 18.71C19.383 18.8037 19.4936 18.8781 19.6154 18.9289C19.7373 18.9797 19.868 19.0058 20 19.0058C20.132 19.0058 20.2627 18.9797 20.3846 18.9289C20.5064 18.8781 20.617 18.8037 20.71 18.71C20.8037 18.617 20.8781 18.5064 20.9289 18.3846C20.9797 18.2627 21.0058 18.132 21.0058 18C21.0058 17.868 20.9797 17.7373 20.9289 17.6154C20.8781 17.4936 20.8037 17.383 20.71 17.29ZM12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16H8C7.73478 16 7.48043 16.1054 7.29289 16.2929C7.10536 16.4804 7 16.7348 7 17C7 17.2652 7.10536 17.5196 7.29289 17.7071C7.48043 17.8946 7.73478 18 8 18H12Z"
              fill="#bcc0c4"
            />
            <!-- #20409B -->
          </svg>
          <input
            v-show="false"
            type="file"
            ref="uploadFiles"
            multiple
            @change="(e) => requestUploadFile(e.target.files)"
          />
          <b-form-textarea
            id="textarea-formatter"
            v-model="content"
            placeholder="Enter your text"
            class="mr-1 pr-2 scrollbar"
            rows="2"
            max-rows="3"
            style="padding-right: 1.75rem !important"
          ></b-form-textarea>
          <button class="button-none" @click="submitComment">
            <svg
              v-if="!loading"
              class="cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.5 14L1.51 3L22.5 12L1.51 21L1.5 14ZM11.02 9.25L3.51 6.03L3.50627 10.5006L3.5 17.97L11.01 14.75L16.7478 11.9635L11.02 9.25Z"
                :fill="(content || attachment_url_list.length) ? '#20409B' : '#ccc'"
              />
              <path
                d="M3.50627 10.5006L3.50374 13.5L9.50374 12L6.50374 11.25L3.50627 10.5006Z"
                :fill="(content || attachment_url_list.length) ? '#20409B' : '#ccc'"
              />
            </svg>
            <div v-else-if="loading" class="follow-the-leader">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </button>
        </b-row>
        <!-- nhập gì đó... -->
      </b-card-footer>
    </b-collapse>
    <hr class="m-0" />
    <b-card-header
      v-if="!show"
      header-tag="header"
      class="p-1 cursor-pointer header mx-auto"
      header-bg-variant="primary"
      header-text-variant="white"
      style="width: 250px"
      role="tab"
      :class="show ? null : 'collapsed'"
      :aria-expanded="show ? 'true' : 'false'"
      aria-controls="collapse-4"
      @click="() => {
        markNewCommentAsRead()
        show = !show
      }"
    >
      <strong
        >{{ $t("lbl_contact") }}<b-badge v-if="unread" class="ml-1" variant="danger" pill>{{ $t("lbl_new") }}</b-badge></strong
      >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="transform: rotate(180deg)"
      >
        <path
          d="M17 9.17C16.8126 8.98375 16.5592 8.87921 16.295 8.87921C16.0308 8.87921 15.7774 8.98375 15.59 9.17L12 12.71L8.46001 9.17C8.27265 8.98375 8.0192 8.87921 7.75501 8.87921C7.49082 8.87921 7.23737 8.98375 7.05001 9.17C6.95628 9.26297 6.88189 9.37357 6.83112 9.49543C6.78035 9.61729 6.75421 9.74799 6.75421 9.88C6.75421 10.012 6.78035 10.1427 6.83112 10.2646C6.88189 10.3864 6.95628 10.497 7.05001 10.59L11.29 14.83C11.383 14.9237 11.4936 14.9981 11.6154 15.0489C11.7373 15.0997 11.868 15.1258 12 15.1258C12.132 15.1258 12.2627 15.0997 12.3846 15.0489C12.5064 14.9981 12.617 14.9237 12.71 14.83L17 10.59C17.0937 10.497 17.1681 10.3864 17.2189 10.2646C17.2697 10.1427 17.2958 10.012 17.2958 9.88C17.2958 9.74799 17.2697 9.61729 17.2189 9.49543C17.1681 9.37357 17.0937 9.26297 17 9.17Z"
          fill="white"
        />
      </svg>
    </b-card-header>
  </b-card>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import appUtils from "@/utils/appUtils";
import { debounce } from "lodash";

export default {
  name: "CommentSection",
  components: {
    ToastificationContent,
  },
  props: {
    order: {
      default: () => {}
    },
    isProcessor: {
      default: false
    }
  },
  data() {
    return {
      show: false,
      comments: [],
      pagination: {},
      content: "",
      attachment_url_list: [],
      appUtils,
      loading: false,
      unread: false,
      loading: false
    };
  },
  computed: {
    order_processor_id() {
      return this.isProcessor ? +this.$route.params.id : this.order.order_items?.[0]?.data.order_processor ? this.order.order_items?.[0]?.data.order_processor.id : 0
    },
    order_supplier_id() {
      return this.isProcessor ? 0 : this.order.id
    },
    disableLoadMore() {
      return (
        !this.show || this.pagination.page_num === this.pagination.total_page
      );
    },
    list_attachments_file() {
      return this.attachment_url_list.map((url) => {
        if (url.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null)
          return {
            url: url,
            type: "image",
          };
        else
          return {
            url: url,
            type: "text",
            name: url.substring(url.lastIndexOf("/") + 1).length > 23 ? appUtils.truncateHash(url.substring(url.lastIndexOf("/") + 1), 20) : url.substring(url.lastIndexOf("/") + 1)
          };
      });
    },
    hasNewComment() {
      return this.order.order_read_flag===1
    }
  },
  watch: {
    order_processor_id: async () => {
      await this.getComments();
    },
  },
  async created() {
    await this.getComments();
    if (this.hasNewComment) {
      this.unread = true
    }
  },
  methods: {
    async translate(content, cmtIndex) {
      const targetLang = this.$i18n.locale === "en" ? "en" : "vi"
      await fetch(`https://translation.googleapis.com/language/translate/v2?key=AIzaSyDeH4LlyI9E9cEALm7hJZ0CNAGzcthozt8&q=${content}&target=${targetLang}`, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "authorization": ""
        }
      })
      .then(data => {
        return data.json()
      })
      .then(json => {
        this.$set(this.comments[cmtIndex], "translatedContent", json.data.translations[0].translatedText)
        this.$set(this.comments[cmtIndex], "isShowTranslation", true)
      });
    },
    async markNewCommentAsRead() {
      const key = this.isProcessor ? "order_processor_id" : "order_supplier_id"
      const param = {[key]: this[key]}
      await this.$rf
        .getRequest("CommonRequest")
        .markNewCommentsAsRead(param)
        .then((res) => {
        })
    },
    submitComment: debounce(async function() {
      if (!this.content && !this.attachment_url_list.length) return;
      this.loading = true
      try {
        let mediaUrlString = this.attachment_url_list.join()
        let param = {
          content: this.content,
          order_processor_id: this.order_processor_id,
          order_supplier_id: this.order_supplier_id,
          send_at: Date.now(),
          medias: mediaUrlString,
          send_from: this.isProcessor ? 1 : 2,
          org_id: appUtils.getLocalUser()[this.isProcessor ? "processorsInfo" : "supplierInfo"].org_id
        };
        setTimeout(async () => {
          await this.$rf
            .getRequest("CommonRequest")
            .postComment(param)
            .then((res) => {
              const user = appUtils.getLocalUser();
              let newComment = {
                ...param,
                newComment: true,
                id: Date.now(),
                order_processor_id: this.order_processor_id,
                order_supplier_id: this.order_supplier_id,
                send_by: user.id,
                name: user.name,
                avatar: user.avatar,
                medias: !mediaUrlString.length ? [] : this.list_attachments_file,
                org_name: appUtils.getLocalUser()[this.isProcessor ? "processorsInfo" : "supplierInfo"].name
              };
              this.$set(this, "comments", [newComment, ...this.comments])
              this.content = "";
              this.attachment_url_list = []
            })
            .then(() => {
              this.loading = false
            });
        }, 1000);
      } catch (e) {
        console.log(e);
      }
    }, 500),
    getMoreComments() {
      if (this.disableLoadMore) return;
      else this.getComments(true);
    },
    async getComments(loadMore = false) {
      try {
        let params = {
          order_processor_id: this.order_processor_id,
          order_supplier_id: this.order_supplier_id
        };
        if (loadMore)
          params = {
            ...params,
            page_num: this.pagination.page_num + 1,
            page_size: this.pagination.page_size,
          };
        await this.$rf
          .getRequest("CommonRequest")
          .getComments(params)
          .then((res) => {
            let comments = (res.data.data && res.data.data.length) ? res.data.data.map(cmt => {
              return cmt.medias.trim() !== "" ?
                {
                  ...cmt,
                  medias: cmt.medias?.split(",").map(url => {
                    return {
                      url: url,
                      type: url.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null ? "image" : "text",
                      name: url.substring(url.lastIndexOf("/") + 1).length > 23 ? appUtils.truncateHash(url.substring(url.lastIndexOf("/") + 1), 20) : url.substring(url.lastIndexOf("/") + 1)
                    }
                  })
                } : {
                  ...cmt,
                  medias: []
                }
            }) : []
            this.comments = loadMore
              ? [...this.comments, ...comments]
              : comments;
            this.pagination = res.data.page;
          })
          .then(() => {});
      } catch (e) {
        console.log(e);
      }
    },
    handleTriggerUploadFile() {
      this.$refs.uploadFiles.click();
    },
    async requestUploadFile(files) {
      if (!files?.length) return;
      try {
        this.loading = true;
        let urlArr = new Array(files.length);
        const promise_list = Array.from(files).map(async (file, fileIndex) => {
          const params = {
            file: file,
            NameTarget: "CommentAttachments",
            IdTarget: +this.$route.params.id,
          };
          const formData = new FormData();

          for (const key in params) {
            formData.append(key, params[key]);
          }

          let data = await this.$rf
            .getRequest("CommonRequest")
            .uploadFileTenant(formData);
          urlArr[fileIndex] = data.data.fileUrl;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t("lbl_upload_file_successfully"),
              icon: "CheckIcon",
              variant: "success",
            },
          });
          return;
        });
        Promise.all(promise_list).then(() => {
          this.attachment_url_list = [...this.attachment_url_list, ...urlArr];
          this.loading = false;
        });
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("lbl_an_error_occurred_while_uploading"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    removeAttachment(index) {
      this.attachment_url_list = this.attachment_url_list.filter((url, i) => i!==index)
    }
  },
};
</script>

<style lang="scss" scoped>
.hover-undeline {
  font-size: 12px;
  display: inline-block;
  color: grey;
  &:hover {
    text-decoration: underline;
  }
}
.button-none {
  background-color: transparent;
  border: none;
  color: white;
  cursor: pointer;
  &:focus-visible {
    outline: #4b6ecf dotted 0.5px;
  }
}
.comments-container {
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 700px;
  max-width: 700px;
  z-index: 1000;
  .header {
    &:first-child {
      border-radius: 0.428rem 0.428rem 0 0;
    }
    width: 700px;
    border-radius: 0.428rem;
  }
  .comments {
    overflow: auto;
    max-height: calc(100vh - 275px);
    background-color: #f9fafb;
  }
  .attachments {
    gap: 10px;
  }
  .card-footer {
    .upload-icon {
      right: 58px;
    }
  }
  .bg-grey {
    background-color: #ccc;
    padding: 0.5rem;
    max-width: 180px;
    .b-avatar.badge-light-primary {
      background-color: white;
    }
    .file-name {
      color: black;
      padding-left: 0.5rem;
      word-break: break-all;
    }
    .close {
      background-color: aliceblue;
      right: 0;
      top: 0;
      border-radius: 50% !important;
      width: 28px;
      transform: translate(40%, -40%);
    }
  }
}
.new-comment {
  background-color: white;
  animation-name: new-comment;  
  animation-duration: 1.5s;
}
@keyframes new-comment {
  from {
    background-color: #8698c9;
  }
  to {
    background-color: white;
  }
}

.scrollbar {
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    width: 5px;
    background-color: #0caee9;
    border-radius: 20px;
    border: 6px solid #a8bbbf;
    background-clip: content-box;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #000d0f;
  }
}
@keyframes follow-the-leader {
  0% {
    -webkit-transform: rotate(0deg) translateY(-200%);
    transform: rotate(0deg) translateY(-200%);
  }

  60%,
100% {
    -webkit-transform: rotate(360deg) translateY(-200%);
    transform: rotate(360deg) translateY(-200%);
  }
}
.follow-the-leader {
  height: 5px;
  position: relative;
  width: 5px;
}
.follow-the-leader div {
  -webkit-animation: follow-the-leader 1.875s infinite backwards;
  animation: follow-the-leader 1.875s infinite backwards;
  background-color: #ffb86c;
  border-radius: 100%;
  height: 100%;
  position: absolute;
  width: 100%;
}
.follow-the-leader div:nth-child(1) {
  -webkit-animation-delay: 0.15s;
  animation-delay: 0.15s;
  background-color: rgba(255, 184, 100, 0.9);
}
.follow-the-leader div:nth-child(2) {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
  background-color: rgba(255, 184, 100, 0.8);
}
.follow-the-leader div:nth-child(3) {
  -webkit-animation-delay: 0.45s;
  animation-delay: 0.45s;
  background-color: rgba(255, 184, 100, 0.7);
}
.follow-the-leader div:nth-child(4) {
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
  background-color: rgba(255, 184, 100, 0.6);
}
.follow-the-leader div:nth-child(5) {
  -webkit-animation-delay: 0.75s;
  animation-delay: 0.75s;
  background-color: rgba(255, 184, 100, 0.5);
}
</style>